import pl from "@locales/store_order/pl.json";
import en from "@locales/store_order/en.json";

export default {
  pl: pl,
  en: en,
};
